<template>
  <div data-cy="skin-profile-row" class="skin-profile-row">
    <figure class="mb-3">
      <img class="skin-profile-row__img" :src="url" />
    </figure>

    <div class="skin-profile-row__heading mb-4">
      <h3>{{ date }}</h3>
      <button
        class="skin-profile-row__delete-button"
        data-cy="delete-button"
        @click="showConfirmModal"
      >
        <fa icon="times-circle" type="far" />
      </button>
    </div>

    <div class="skin-profile-row__info">
      <SkinProfileIcon
        v-for="(info, index) in skinInfo"
        :key="index"
        :icon="info.icon"
        :icon-color="info.iconColor"
        :icon-type="info.iconType"
        :label="info.label"
        :title="info.title"
      />
    </div>

    <ConfirmModal
      v-if="isDeleting"
      @click="emitDelete"
      @close="closeConfirmModal"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { SkinProfile } from "@/controller/skin-profile";
import SkinProfileIcon from "./SkinProfileIcon.vue";
import ConfirmModal from "./ConfirmModal.vue";

interface SkinInfo {
  icon: string;
  iconColor: string;
  iconType: string;
  label: string;
  title: string;
}

export default defineComponent({
  name: "SkinProfileRow",

  components: {
    SkinProfileIcon,
    ConfirmModal
  },

  props: {
    skinProfile: {
      type: Object as PropType<SkinProfile>,
      required: true
    }
  },

  data() {
    return {
      isDeleting: false
    };
  },

  computed: {
    url(): string {
      return this.skinProfile.url;
    },

    date(): string {
      const date = this.skinProfile.date;
      const year = date.getFullYear();
      const day = date.getDate();
      const month = date.getMonth() + 1;
      return `${day} Tháng ${month}, ${year}`;
    },

    skinInfo(): SkinInfo[] {
      return [
        {
          icon: "heart",
          iconColor: "red",
          iconType: "fas",
          title: "Cảm thấy",
          label: this.skinProfile.feeling
        },
        {
          icon: "allergies",
          iconColor: "orange",
          iconType: "fas",
          title: "Loại da",
          label: this.skinProfile.skinType
        },
        {
          icon: "clock",
          iconColor: "navy",
          iconType: "fas",
          title: "Thời gian",
          label: this.skinProfile.skinTime
        },
        {
          icon: "moon",
          iconColor: "darkseagreen",
          iconType: "fas",
          title: "Giấc ngủ",
          label: this.skinProfile.sleep
        },
        {
          icon: "clipboard",
          iconColor: "black",
          iconType: "far",
          title: "Ghi chú",
          label: this.skinProfile.note
        }
      ];
    }
  },

  methods: {
    showConfirmModal() {
      this.isDeleting = true;
    },

    closeConfirmModal() {
      this.isDeleting = false;
    },

    emitDelete() {
      this.$emit("delete", this.skinProfile.id);
      this.closeConfirmModal();
    }
  }
});
</script>

<style lang="scss" scoped>
.skin-profile-row {
  text-align: left;
}

.skin-profile-row__img {
  max-width: 500px;
  width: 100%;

  object-fit: cover;
}

.skin-profile-row__heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid lightgrey;
}

.skin-profile-row__delete-button {
  width: 25px;
  height: 25px;
  border: none;
  background: none;
  color: red;

  &:hover {
    color: $grey;
  }
}

.skin-profile-row__info {
  display: grid;

  grid-template-columns: 1fr;
  row-gap: 1rem;
}
</style>
